export const environment = {
  production: true,
  recaptchav2_sitekey: '6Lc4yfUdAAAAANgu1ftlPka2rypLuetl-KCiGUXm',
  recaptchav3_sitekey: '6LcU4hIkAAAAAObnsRqGMJONaj8fJ7geh_4WEfHn',
  // recaptcha_mode can take only one of these values in 'v2' or 'v3'
  recaptcha_mode: 'v2'
};
